export const STORAGE_ADDRESS_PATTERN = 'StorageAddressPattern';
export const StorageAddressComponentTypeValues = [
    'numeric',
    'alpha',
    'alphanumeric',
];
export const STORAGE_ADDRESS_COMPONENT_TYPE_LABELS = {
    numeric: 'Numérico',
    alpha: 'Alfabético',
    alphanumeric: 'Alfanumérico',
};
/**
 * Suggested labels for a pattern component (0168 §2.5). Suggestion, not enum —
 * the client that calls it "Vão" types "Vão".
 */
export const STORAGE_ADDRESS_COMPONENT_LABEL_SUGGESTIONS = [
    'Rua',
    'Corredor',
    'Prédio',
    'Módulo',
    'Estante',
    'Coluna',
    'Nível',
    'Andar',
    'Posição',
    'Gaveta',
    'Box',
    'Doca',
    'Palete',
];
/** Seed / default pattern equivalent to the 0115 `R{}-P{}-N{}-A{}` format. */
export const PORTA_PALETE_STORAGE_ADDRESS_CODE = 1;
export const PORTA_PALETE_STORAGE_ADDRESS_MASK = 'R{rua}-P{predio}-N{nivel}-A{posicao}';
export const PORTA_PALETE_STORAGE_ADDRESS_COMPONENTS = [
    { key: 'rua', label: 'Rua', type: 'numeric', width: 2 },
    { key: 'predio', label: 'Prédio', type: 'numeric', width: 2 },
    { key: 'nivel', label: 'Nível', type: 'numeric', width: 2 },
    { key: 'posicao', label: 'Posição', type: 'numeric', width: 2 },
];
export function makePortaPaleteStorageAddressPatternDraft() {
    return {
        code: PORTA_PALETE_STORAGE_ADDRESS_CODE,
        name: 'Porta-palete',
        components: PORTA_PALETE_STORAGE_ADDRESS_COMPONENTS.map((c) => ({ ...c })),
        mask: PORTA_PALETE_STORAGE_ADDRESS_MASK,
        defaultKind: 'picking',
        defaultCapacity: null,
    };
}
//# sourceMappingURL=storage-address-pattern.js.map